import { render, staticRenderFns } from "./course-info.vue?vue&type=template&id=3020ad48&scoped=true&"
import script from "./course-info.vue?vue&type=script&lang=ts&"
export * from "./course-info.vue?vue&type=script&lang=ts&"
import style0 from "./course-info.vue?vue&type=style&index=0&id=3020ad48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020ad48",
  null
  
)

export default component.exports